import React, { Component } from 'react'
import cx from 'classnames'
import { Layout, Container, PageTitle } from 'src/components/Layout'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Box, Text, Image } from '@chakra-ui/react'
import { getAddressFromUser, hasFeatureFlag } from 'src/utils/helpers'
import { Link } from 'react-router-dom'

import styles from './UserProfile.module.less'
import intlMessages from '../translations'

class UserProfile extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  render() {
    const {
      intl,
      user,
      user: { name },
      featureFlags,
      countryIsoCode,
    } = this.props

    const address = getAddressFromUser(user)

    return (
      <Layout>
        <PageTitle
          subtitle={intl.formatMessage(intlMessages.usersProfileHeadline)}
          title={<FormattedMessage id='app.profile.yourProfile' defaultMessage='Your Profile' />}
        />
        <Container padder className='global-centered-desktop-content'>
          <Box
            className={cx({
              [styles.card]: true,
              [styles.cardWithoutContactAccess]: !hasFeatureFlag(featureFlags, 'pages.contact'),
            })}
          >
            <Box pos={'relative'}>
              <Image borderRadius={'100%'} src={user.avatar} w={'96px'} h={'96px'} alt='avatar' />

              {/* @todo need new endpoint for edit profile image on kiosk side */}
              {/* <Box className={styles.avatarEditBox} cursor={'pointer'}>
                <Box className={styles.avatarEdit}>
                   <FontAwesomeIconComponent icon={['fal', 'pen']} size="xs" />
                </Box>
              </Box> */}
            </Box>
            <Text
              wordBreak={'break-word'}
              px={'20px'}
              mt={'16px'}
              fontSize={'18px'}
              fontWeight={'bold'}
            >
              {name || '-'}
            </Text>
            <Text wordBreak={'break-word'} px={'20px'} fontSize={'14px'} opacity={0.7}>
              {user.email || '-'}
            </Text>
            {address && address.length > 0 ? (
              <Text
                wordBreak={'break-word'}
                px={'20px'}
                mt={'16px'}
                fontSize={'14px'}
                opacity={0.8}
                align={'center'}
              >
                {address}{' '}
              </Text>
            ) : (
              ''
            )}
            {hasFeatureFlag(featureFlags, 'pages.contact') ? (
              <Box
                as={Link}
                to='/contact'
                _focus={{ border: '2px solid', borderColor: 'black' }}
                _focusVisible={{ border: '2px solid', borderColor: 'black' }}
                borderTopWidth={'1px'}
                borderTopColor={'#E2E8F0'}
                py={'8px'}
                mt={'17px'}
                w={'100%'}
                onKeyDown={e => {
                  if (e.key == ' ' || e.code == 'Space' || e.keyCode == 32) {
                    this.props.history.push('/contact')
                  }
                }}
              >
                <Text fontSize={'14px'} color={'#3D4045'}>
                  {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
                    <FormattedMessage
                      id='app.header.links.myAgent'
                      defaultMessage='View My Agent'
                    />
                  ) : (
                    <FormattedMessage
                      id='app.header.links.myBroker'
                      defaultMessage='View My Broker'
                    />
                  )}
                </Text>
              </Box>
            ) : (
              ''
            )}
          </Box>
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(UserProfile)
